<div class="kt-form">
	<h6>{{data.site.id !== -1 ? data.site.name : 'New site'}}</h6>
	<mat-form-field class="example-full-width mt-3">
		<input [(ngModel)]="result.name" matInput placeholder="Website name">
<!--		<mat-hint>A description for your site</mat-hint>-->
	</mat-form-field>
	<mat-form-field class="example-full-width mt-3">
		<input [(ngModel)]="result.url" matInput placeholder="Website url">
<!--		<mat-hint>The site' s Url</mat-hint>-->
	</mat-form-field>
	<mat-checkbox class="example-margin mt-3" [(ngModel)]="result.active">Active</mat-checkbox>
</div>
<div class="row mb-2 no-gutters mt-3">
  <div class="col-12">
    <button mat-button class="float-left ml-2" (click)="onNoClick()">Cancel</button>&nbsp;
    <button mat-button class="float-right mr-2" (click)="onYesClick()" [disabled]="result.name.length === 0 || result.url.length === 0" color="primary">OK</button>
  </div>
</div>
